<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Petrotranz Report</h2>
      </b-col>
      <!--Gear Icon :data            :data   = "items_csv"      @click="openExcel()"          = "items"   ref="excel"   v-b-popover.hover.top="'Export to csv'"   @click="openExcel()"         :data   = "items" -->
       <!-- <b-col cols="8" lg="6">
            <download-excel
                ref="excel"
                :data   = "items_csv" 
                :fields = "json_fields"
                type    = "csv"
                :name   = "filename">   
                <span>
                <b-btn class="pull-right ml5" v-b-popover.hover.top="'Export to csv'" variant="info"><i class="fa fa-file-excel-o"></i></b-btn>           
                </span>
            </download-excel>
        </b-col> -->
    </div>

    <!-- Filters block-->
    <div class="filters pb-2">
      <b-row>

        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>
      </b-row> 
        <b-row>
          <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>  
          <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col> 
         </b-row>
    </div>

    <!-- Main table block -->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div v-else class="table-responsive p-0 m-0">
          <b-table 
            class="animated fadeIn" 
            striped 
            bordered
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            @filtered="onFiltered" 
            :filter="filter" 
            @row-clicked="rowClicked"
          >
          </b-table> 
        </div>
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import service from './receipt_service'
  import moment from 'moment'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'PetroTranz',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        row                 : 0,
        loadingData         : true,
        configTable         : false,

        items               : items,
        totalRows           : items.length,
        fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'haul_id',
          label: 'Haul ID',
          sortable: true,
        }, 
        {
          key: 'success',
          label: 'Success',
        },
        {
          key: 'send_date',
          label: 'Send Date',
          sortable: true,
          formatter: (value) => { return moment(value).format("MMM DD, YYYY HH:MM:SS") }
        },
        {
          key: 'message',
          label: 'Message',
        },
        ],
        currentPage               : 1,
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
        modalInfo                 : {
          title: '',
          content: ''
        },
        modalEdit                 : {
          title: ''
        },
		    role                      :'',
        myToggle                  :false,
        // export to csv
        filename : 'petrotranz'+moment().format('YYYYMMDDHHMM')+'.csv',        
        json_fields: {
          "id"            : "id",
          "haul_id"       : "haul_id",
          "success"       : "success",
          "send_date"     : "send_date",
          "message"       : "message",
       },
       items_csv: [],
        filter_by:{ "initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
                    "end_date"    : moment().endOf('week').format('YYYY-MM-DD') 
                  },
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getAll() {
        this.items = []
        //this.v_items = []
        console.log(this.filter_by)
        service.get_petrotranz_hauls(this.filter_by)
          .then(data => {
            if (data.status == 'success') {
              this.items        = data.hauls    //.filter(o => o.status_id == (this.trash ? 2 : 1))
              this.items_csv    = this.items 
              //this.getAll1()
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      rowClicked(row, index, e) {
        console.log('click')
        //e.preventDefault()
        //let to_popup = {'id':row.haul_id,'haul_invoice':false,'edit':''}
        //this.$root.$emit('openPopup', to_popup);
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
        }
        this.filter_by.initial_date = a
        this.getAll()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
        }
        this.filter_by.end_date = a
        this.getAll()
        this.loadingData = true
      },
      clearFilters() {
        this.filter_by = {"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
                            "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
                          }
        this.getAll()
        this.loadingData = true
      },  
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/receipt/petrotranz_report.vue